import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configureForage } from './utilities/forage';
import { store } from './redux/store';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/main.scss';
import UserTypesProvider from './utilities/context/UserTypesContext';

configureForage();

ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <UserTypesProvider>
      <App />
    </UserTypesProvider>
  </Provider>,
  // </React.StrictMode>,
  document.getElementById('root')
);
